<script>
import { BDropdown } from "bootstrap-vue";

export default {
  extends: BDropdown
};
</script>